import React, { useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisH } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import { IconButton, ImageListItemBar } from '@mui/material';
import FileViewer from './filePreview/file-viewer';

function File({
  url, mimeType, description, onOpenMenu,
}) {
  const ref = useRef();
  return (
    <>
      <FileViewer url={url} mimeType={mimeType} />
      <ImageListItemBar
        position="top"
        title={description}
        actionIcon={(
          <IconButton onClick={() => onOpenMenu(ref, url)} ref={ref}>
            <FontAwesomeIcon icon={faEllipsisH} color="white" />
          </IconButton>
        )}
      />
    </>
  );
}

File.propTypes = {
  url: PropTypes.string.isRequired,
  mimeType: PropTypes.string.isRequired,
  description: PropTypes.string,
  onOpenMenu: PropTypes.func.isRequired,
};

File.defaultProps = {
  description: '',
};

export default File;
